<template>
    <form ref="form">
        <div class="card mb-1">
            <div class="card-body py-1">
                <div class="row mb-2">
                    
                    <!-- 顧客番号と検索ボタン -->
                    <input-kokyk-id-with-button
                        v-model="form.KOKYK_ID"
                        @set-customer="setCustomerInfo"
                        :dg="dg"
                        :del-flag="delFlagList"
                        :errors="errors"
                        :syzk-list="syzkList"
                    ></input-kokyk-id-with-button>

                    <!-- 顧客名 -->
                    <div class="col-2">
                        <label for="CLNIC_NM" class="form-label">{{ dg.MKokykLic.CLNIC_NM }}</label>
                        <input type="text" name="CLNIC_NM" class="form-control form-control-sm" id="CLNIC_NM" v-model="form.CLNIC_NM">
                        <error-message :error="errors.CLNIC_NM"></error-message>
                    </div>

                    <!-- 状態 -->
                    <div class="col-1">
                        <label for="STATUS" class="form-label form-label-sm">{{ dg.SalTLetsin.STATUS }}</label>
                        <select name="STATUS" class="form-select form-select-sm" id="STATUS" v-model="form.STATUS">
                            <option v-for="(status, index) in letsinStatusList" :key="index" :value="index">{{ status }}</option>
                        </select>
                        <error-message :error="errors.STATUS"></error-message>
                    </div>

                    <!-- 開始日 -->
                    <div class="col-2" style="width: 130px">
                        <label for="START_DATE" class="form-label">{{ dg.SalTLetsin.START_DATE }}</label>
                        <input type="date" name="START_DATE" class="form-control form-control-sm" id="START_DATE" @blur="focusOut" v-model="form.START_DATE">
                        <error-message :error="errors.START_DATE"></error-message>
                    </div>

                    <!-- 終了日 -->
                    <div class="col-2" style="width: 130px">
                        <label for="END_DATE" class="form-label">{{ dg.SalTLetsin.END_DATE }}</label>
                        <input type="date" name="END_DATE" class="form-control form-control-sm" id="END_DATE" @blur="focusOut" v-model="form.END_DATE">
                        <error-message :error="errors.END_DATE"></error-message>
                    </div>

                    <!-- 連絡用メールアドレス -->
                    <div class="col-3">
                        <label for="MAIL" class="form-label">{{ dg.SalTInsite.MAIL }}</label>
                        <input type="text" name="MAIL" class="form-control form-control-sm" id="MAIL" @blur="focusOut" v-model="form.MAIL">
                        <error-message :error="errors.MAIL"></error-message>
                    </div>
                    
                    <!-- 連絡先氏名 -->
                    <div class="col-2">
                        <label for="CONTACT_NAME" class="form-label">{{ dg.SalTInsite.CONTACT_NAME }}</label>
                        <input type="text" name="CONTACT_NAME" class="form-control form-control-sm" id="CONTACT_NAME" @blur="focusOut" v-model="form.CONTACT_NAME">
                        <error-message :error="errors.CONTACT_NAME"></error-message>
                    </div>
                </div>

                <div class="row mb-2">  
                    <!-- URL -->
                    <div class="col-3">
                        <label for="URL" class="form-label">{{ dg.SalTLetsin.URL }}</label>
                        <input type="text" name="URL" class="form-control form-control-sm" id="URL" v-model="form.URL">
                        <error-message :error="errors.URL"></error-message>
                    </div>

                    <!-- U_ID -->
                    <div class="col-1">
                        <label for="U_ID" class="form-label">{{ dg.SalTLetsin.U_ID }}</label>
                        <input type="text" name="U_ID" class="form-control form-control-sm" id="U_ID" v-model="form.U_ID">
                        <error-message :error="errors.U_ID"></error-message>
                    </div>

                    <!-- U_PASS -->
                    <div class="col-2">
                        <label for="U_PASS" class="form-label">{{ dg.SalTLetsin.U_PASS }}</label>
                        <input type="text" name="U_PASS" class="form-control form-control-sm" id="U_PASS" v-model="form.U_PASS">
                        <error-message :error="errors.U_PASS"></error-message>
                    </div>
                </div>
                <div class="row mb-2">  
                    <!-- MURL -->
                    <div class="col-3">
                        <label for="MURL" class="form-label">{{ dg.SalTLetsin.MURL }}</label>
                        <input type="text" name="MURL" class="form-control form-control-sm" id="MURL" v-model="form.MURL">
                        <error-message :error="errors.MURL"></error-message>
                    </div>

                    <!-- M_ID -->
                    <div class="col-1">
                        <label for="M_ID" class="form-label">{{ dg.SalTLetsin.M_ID }}</label>
                        <input type="text" name="M_ID" class="form-control form-control-sm" id="M_ID" v-model="form.M_ID">
                        <error-message :error="errors.M_ID"></error-message>
                    </div>

                    <!-- M_PASS -->
                    <div class="col-2">
                        <label for="M_PASS" class="form-label">{{ dg.SalTLetsin.M_PASS }}</label>
                        <input type="text" name="M_PASS" class="form-control form-control-sm" id="M_PASS" v-model="form.M_PASS">
                        <error-message :error="errors.M_PASS"></error-message>
                    </div>
                </div>
                <div class="mb-2 row">
                    <!-- ファイル -->
                    <file-upload
                        v-model="form"
                        v-model:filesModelValue="files"
                        :dg="dg"
                        :max-file-count=3
                        :slice-num=29
                        :document-root="documentRoot"
                    ></file-upload>
                </div>
                <div class="row mb-2">
                    <!-- 備考 -->
                    <div class="col-12">
                        <label for="NOTE" class="form-label">{{ dg.NOTE }}</label>
                        <textarea name="NOTE" class="form-control form-control-sm" id="NOTE" v-model="form.NOTE" rows="22"></textarea>
                    </div>
                </div>
            </div>   
        </div>
        <div class="d-grid gap-2 d-md-flex justify-content-md-end">
            <!-- 削除ボタン -->
            <delete-button v-if="edit"
                :confirm-message="dg.deleteConfirmMessage"
                :dg="dg"
                :url="`/letsin/${form.ID}`"
            >{{ dg.Delete }}</delete-button>
            <!-- 中止ボタン -->
            <cancel-button
                :confirm-flag="changed"
                :confirm-message="dg.cancelMessage"
                :url="`${documentRoot}/letsin`"
            >{{ dg.cancel }}</cancel-button>
            <button type="button" class="btn btn-primary" @click="register">登録</button>
        </div>
        <modal-dialog ref="dialog"
            :dg = dg
            @update="update"
        ></modal-dialog>

    </form>
</template>

<script>
import CancelButton from '../buttons/CancelButton.vue';
import DeleteButton from '../buttons/DeleteButton.vue';
import InputKokykIdWithButton from '../inputs/InputKokykIdWithButton.vue';
import ModalDialog from '../modals/ModalDialog.vue';
import FileUpload from '../inputs/FileUpload.vue';

export default {
    name: 'LetsinInput',
    components: {
        CancelButton,
        DeleteButton,
        FileUpload,
        InputKokykIdWithButton,
        ModalDialog,
    },
    props: {
        data                : Object,
        dg                  : Object,
        documentRoot        : String,
        delFlagList         : Object,
        letsinStatusList    : Object,
        syzkList            : Object,
    },
    data() {
        return {
            changed: false,
            edit: false,
            errors: {},
            files: [],
            form: {},
        }
    },
    created() {
        this.form = this.data;
        this.edit = this.form.ID ? true : false;
    },
    mounted() {
        const unwatch = this.$watch('form', () => {
            this.changed = true;
            unwatch();
        },{ deep: true });
    },
    methods: {
        register() {
            this.edit ? this.$refs.dialog.open() : this.create();
        },
        setCustomerInfo(SalTLetsin) {
            const keys = ['KOKYK_ID', 'CLNIC_NM'];

            for (const key of keys) {
                this.form[key] = SalTLetsin[key];
            }
        },
        getFormData () {
            const formData = new FormData(this.$refs.form);

            formData.set('FILE1', '');
            formData.set('FILE2', '');
            formData.set('FILE3', '');
            for (let i = 0; i < this.files.length; i++) {
                if (this.files[i].file) {
                    formData.set('FILE' + (i + 1), this.files[i].file);
                } else {
                    formData.set('FILE' + (i + 1), this.files[i].name);
                }
            }

            return formData;
        },
        create() {
            axios.post(`/letsin`, this.getFormData(), {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
            .then((res) => {
                location.href = res.data;
            })
            .catch((error) => {
                if (error.response.status === 422) {
                    this.errors = error.response.data.errors;
                } else if (error.response.status === 500) {
                    const status = error.response.status;
                    window.alert(this.dg.internal_error);
                }
            });
        },
        update() {
            axios.post(`/letsin/${this.form.ID}`, this.getFormData(), {
                headers: {
                    "Content-Type": "multipart/form-data",
                    'X-HTTP-Method-Override' : 'PUT',
                },
            })
            .then((res) => {
                location.href = res.data;
            })
            .catch((error) => {
                if (error.response.status === 422) {
                    this.errors = error.response.data.errors;
                } else if (error.response.status === 500) {
                    const status = error.response.status;
                    window.alert(this.dg.internal_error);
                }
            });
        },
    },
    watch: {
    },
}
</script>